module.exports = __webpack_public_path__ + "img/Mike Holmes.772426ac.jpg";